import { SourceDataInitials } from '@/constants/SourceDataInitials';
import ICompDatas from './ICompDatas';

export default {
    hasInitialsOtherThanFormFiller(compDatas: ICompDatas | undefined): boolean {
        if (compDatas) {
            const compDataIdx = compDatas.findIndex(cd => cd.sourceInitial !== '' && cd.sourceInitial !== SourceDataInitials.FormFiller);
            return compDataIdx >= 0;
        }
        return false;
    }
};
